export const POLICY_CHANGED = "SHAREPOINT_POLICY_CHANGED";

export const AUTH_REQUIRED = "SHAREPOINT_AUTH_REQUIRED";

export const SETTINGS_REQUIRED = "SHAREPOINT_SETTINGS_REQUIRED";

export const INTEGRATION_DISABLED = "SHAREPOINT_INTEGRATION_DISABLED";

export const PAGE_SIZE = 50;

export const POLL_INTERVAL = 1000;

export const POLL_TIMEOUT = 120000;

export const POPUP_BLOCKED =
  "Allow pop-ups for this site to connect to SharePoint.";

export const SIGN_IN_CANCELLED =
  "The SharePoint sign-in window was closed before you signed in.";

export const SIGN_IN_TIMED_OUT = "The SharePoint sign-in timed out. Try again.";

export const SAVE_FAILED = "Saving the allowed sites failed";

export const REQUEST_CONFIG = { skipAuthRedirect: true };
